import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "report-headline",
  "use": "report-headline-usage",
  "viewBox": "0 0 71 70",
  "content": "<symbol viewBox=\"0 0 71 70\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"report-headline\">\n<path d=\"M0.451172 0.0967712V21.5676H14.3738V14.0194H28.2963V55.7871H19.7237V69.7097H50.7916V55.7871H42.2189V14.0194H56.1415V21.5676H70.0641V0.0967712H0.451172Z\" fill=\"#465D65\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol